module.exports = __webpack_public_path__ + "img/air-max-97-tortoise-shell-womens-shoe.f701a4cd.png";